import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ModalManager } from 'react-dynamic-modal';
import fetchJsonp from 'fetch-jsonp';

import Icon from './Icon';
import HatchModal from './HatchModal';
import tracking from '../services/Tracking';
import hatchConfig, { HATCH_ENABLED } from '../constants/hatchConfig';
import { localeFormatted, configuratorType } from '../i18n.js';

class HatchBuyButton extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      retailers: [],
    };

    this.openModal = this.openModal.bind(this);
  }

  componentDidMount() {
    if (HATCH_ENABLED && (localeFormatted === 'nl_NL' || localeFormatted === 'da_DK') ) {
      
      let hatchConfig_cid = configuratorType === 'water' ? hatchConfig.cid_water : hatchConfig.cid_shower;
      
      const { data } = this.props;

      const apiRequest = `${hatchConfig.baseUrl}/${hatchConfig.apiKey}/json?region=${hatchConfig.region}&mpn=${data.id}&CID=${hatchConfig_cid}&direct=bypass&sort=group_name`;

      fetchJsonp(apiRequest)
        .then((response) => response.json())
        .then((json) => {
          this.setState({
            visible: true,
            retailers: json.iceleads_interface.retailers.retailer,
          });
        }).catch((ex) => {
        console.log('parsing failed', ex); // eslint-disable-line no-console
      });
    }
  }

  openModal(event) {
    const { data } = this.props;
    const { retailers } = this.state;

    tracking.event(data.headline, 'buy-now');

    event.stopPropagation();
    event.preventDefault();

    ModalManager.open(<HatchModal retailers={retailers} onRequestClose={() => true} />);
  }

  render() {
    const { tag, additionalClass } = this.props;
    const { visible } = this.state;

    if (!visible || !HATCH_ENABLED) {
      return null;
    }

    let classNames = 'btn btn-block btn-primary button button--result ' + additionalClass;

    const ComponentName = tag;

    return (
      <ComponentName
        target="_blank"
        onClick={this.openModal}
        className={classNames}
        href="#"
      >
        <Icon name="icon-result-button-online-shop" />
        <FormattedMessage id="results.product.button.buyNow" />
      </ComponentName>
    );
  }
}

HatchBuyButton.propTypes = {
  tag: PropTypes.oneOf(['a', 'button']),
  data: PropTypes.object.isRequired,
  additionalClass: PropTypes.string,
};

HatchBuyButton.defaultProps = {
  tag: 'a',
  additionalClass: '',
};

export default HatchBuyButton;



// WEBPACK FOOTER //
// ./src/components/HatchBuyButton.js